import axios from 'axios';
import { del, post } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const saveDocument = async (payload) => {
  const builder = new UrlBuilder(`/storages/save-document`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getS3SignUploadUrl = async (payload) => {
  const builder = new UrlBuilder(`/storages/get-upload-url`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const uploadDirectlyToS3 = async (signUrl, payload, onUploadProgress) => {
  try {
    const response = await axios.post(signUrl, payload, {
      onUploadProgress: (progressEvent) => {
        if (!onUploadProgress || !progressEvent.total) return;
        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onUploadProgress(percent);
      },
    });

    if ([200, 201, 204].includes(response.status)) {
      return response.data;
    }

    throw new Error('Unexpected response from S3 upload');
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to upload file to S3');
  }
};

export const deleteDocument = async (payload) => {
  const builder = new UrlBuilder(`/storages/delete-document`);

  try {
    const response = await del(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const viewDocument = async (payload) => {
  const builder = new UrlBuilder(`/storages/view-document`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const saveDocumentList = async (payload) => {
  const builder = new UrlBuilder(`/storages/save-application`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
